"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const types_1 = require("./types");
class ThinStyle {
    constructor() {
        this.name = types_1.FontStyleName.THIN;
        this.style = graphql_schema_types_1.FontStyle.Normal;
        this.weight = 100;
    }
}
exports.default = ThinStyle;
//# sourceMappingURL=ThinStyle.js.map